// NATIVE
import * as React from 'react';

// INSTALLED
import { DialogContentText, Grid, Slide } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { TransitionProps } from '@mui/material/transitions';

// CUSTOM

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalSessionExpired = (props: any) => {
  const { open, handleCloseModalSessionExpired, buttons = false } = props;

  const handleClose = () => {
    window.location.href = window.location.origin;
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Su session ha expirado
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            Su session ha expirado, lo invitamos a iniciar session nuevamente.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            // disabled={isSubmitting}
            style={{ margin: 5, float: 'right' }}
            onClick={handleClose}
            variant="contained"
            color={'primary'}
          >
            Iniciar session
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
